export default "https://cdn.questicon.mathletics.com/assets/images/session-timeout-0c9bba14aa3c0caf11c700415da20c4f.svg";